import { useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import { ApiUrl } from "../../config";

export default function ConfirmEmailChange() {
  //const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [errorMessage, setErrorMessage] = useState("");
  const hasRun = useRef(false); // 👈 guard against double execution

  useEffect(() => {
    if (hasRun.current) return; // 👈 skip second run
    hasRun.current = true;

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setStatus("error");
      setErrorMessage("Lien invalide ou manquant.");
      return;
    }

    const confirm = async () => {
      try {
        const response = await fetch(`${ApiUrl}email/change/confirm`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();

        if (response.ok) {
          Cookies.remove("access_token", { path: "/" });
          setStatus("success");
          setTimeout(() => {
            window.location.href = "/login?email_confirmed=true";
          }, 3000);
        } else {
          setStatus("error");
          if (response.status === 410) {
            setErrorMessage("Ce lien a expiré. Veuillez faire une nouvelle demande.");
          } else {
            setErrorMessage(data.message || "Une erreur est survenue. Veuillez réessayer.");
          }
        }
      } catch (error) {
        console.log(error);
        setStatus("error");
        setErrorMessage("Erreur réseau. Veuillez réessayer plus tard.");
      }
    };

    confirm();
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {status === "loading" && (
          <>
            <div style={styles.spinner}></div>
            <p style={styles.text}>Confirmation en cours...</p>
          </>
        )}
        {status === "success" && (
          <>
            <div style={styles.iconSuccess}>✓</div>
            <h2 style={styles.title}>Adresse e-mail confirmée !</h2>
            <p style={styles.text}>
              Votre adresse e-mail a été mise à jour avec succès.
              <br />
              Vous allez être redirigé vers la page de connexion...
            </p>
          </>
        )}
        {status === "error" && (
          <>
            <div style={styles.iconError}>✕</div>
            <h2 style={styles.title}>Lien invalide</h2>
            <p style={styles.text}>{errorMessage}</p>
            <button
              style={styles.button}
              onClick={() => (window.location.href = "/login")}
            >
              Retour à la connexion
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    fontFamily: "sans-serif",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "48px 40px",
    maxWidth: "420px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  },
  title: {
    fontSize: "20px",
    fontWeight: "600",
    marginBottom: "12px",
    color: "#1a1a1a",
  },
  text: {
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.6",
  },
  iconSuccess: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "#e6f9f0",
    color: "#22c55e",
    fontSize: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
  },
  iconError: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "#fef2f2",
    color: "#ef4444",
    fontSize: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "3px solid #f3f3f3",
    borderTop: "3px solid #FD7E14",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    margin: "0 auto 16px",
  },
  button: {
    marginTop: "20px",
    padding: "10px 24px",
    backgroundColor: "#FD7E14",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
  },
};